import './App.css';
import WatchEditor from './components/WatchEditor';
function App() {
  return (
    <div className="App">
     <WatchEditor />
    </div>
  );
}

export default App;
